<template>
    <div class="px-primary">
        <div class="row justify-content-end">
            <div class="col-12 col-md-11 col-lg-10">
                <div class="py-5 px-5 px-md-0">
                    <div class="d-flex align-items-center mb-5">
                        <div class="mr-3">
                            <app-icon name="layers"/>
                        </div>
                        <div>
                            <p class="mb-0">
                                The category has {{ data.sub_categories.length }} subcategories
                            </p>
                            <p class="mb-0 text-muted"><span class="text-muted">Total products</span>
                                {{ data.product_count }}
                            </p>
                        </div>
                    </div>
                    <div class="row align-items-center mb-5" v-for="category in data.sub_categories">
                        <div class="col-8 col-md-5 mb-4 mb-md-0">
                            <div class="d-flex align-items-center">
                                <div>
                                    <div class="mb-1">
                                        <app-category-media :row-data="category" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 col-md-3 mb-4 mb-md-0">
                            <p class="text-right text-md-left mb-1">
                                <span class="text-muted">Product</span>
                                {{ category.products_count }}
                            </p>
                        </div> <!---->
                        <div class="col-4 col-md-2 text-right">
                            <default-action :actions="actions" @action="triggerActions" :row-data="category"  />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-category-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('category-table')"
                @cancelled="confirmationModalActive = false"
        />
    </div>
</template>

<script>
    import DefaultAction from "../../../../core/components/datatable/DefaultAction";
    import {deleteAction, editAction} from "../../../Helpers/TableAction";
    import {CATEGORIES} from "../../../Config/ApiUrl";
    import CategoriesMixins from "../../Mixins/CategoriesMixins";

    export default {
        name: "SubCategories",
        components: {DefaultAction},
        mixins: [CategoriesMixins],
        props: {
            data: {
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                actions: [
                    editAction(this.$can('update_categories'), CATEGORIES),
                    deleteAction(this.$can('delete_categories'), CATEGORIES)
                ]
            }
        }
    }
</script>

<style scoped>

</style>